import momentTimezone from 'moment-timezone';

// Given a timezone, return the local time
const localTimeFromTimeZone = timezone => {
    if (!timezone) {
        return '';
    }

    if (!momentTimezone.tz.zone(timezone)) {
        return '';
    }

    const current = momentTimezone();
    return current.tz(timezone).format('LT');
};

export default localTimeFromTimeZone;



// WEBPACK FOOTER //
// ./src/web/js/app/lib/moment/localtime.js